import React from 'react'
import { COLORS } from 'theme'
import Avatar from 'components/Avatar'
import AwardsIconWork from 'components/icons/AwardsIconWork'
import {
  MainHeading,
  SecondaryHeading,
  StyledP,
  GreyText,
  SecondGreyText,
  SubFLex,
} from 'modules/Students/Partials/StudentsInfoTable/ViewStudentDrawer/Partials/StudentDrawerContent/Style/style'

const HonorsAwardsSection = ({ awards }) => {
  return (
    <>
      <MainHeading>Honors & Awards</MainHeading>
      <SubFLex column gap="25px">
        <SubFLex gap="12px">
          <div>
            <Avatar
              background="none"
              src={''}
              size={48}
              icon={<AwardsIconWork />}
              boxShadow={true}
              padding="5px"
            />
          </div>
          <SubFLex column>
            <SecondaryHeading>Student of Integrity Award</SecondaryHeading>
            <SecondGreyText marginBottom="15px">
              {awards?.organization}
            </SecondGreyText>

            <GreyText color={COLORS.GREY_T_60}>{awards?.awarded_on}</GreyText>

            <StyledP webkitBox={true}>{awards?.description}</StyledP>
          </SubFLex>
        </SubFLex>
      </SubFLex>
    </>
  )
}

export default HonorsAwardsSection
